<div class="toastContainer"></div>
<div class="bigger-container">
  <div class="left-section">
    <p class="filter-title">Filtra</p>
    <form class="filters" [formGroup]="form">
      <div>
        <label for="status">Cerca per ID</label>
        <input
          id="filters-doc_ref"
          type="text"
          formControlName="doc_ref"
          placeholder="Cerca per ID"
        />
      </div>
      <div>
        <label for="status">Cerca per nome e cognome</label>
        <input
          id="filters-name"
          type="text"
          formControlName="name"
          placeholder="Cerca per nome/cognome"
        />
      </div>
      <div>
        <label for="status">Cerca per email</label>
        <input
          id="filters-email"
          type="text"
          formControlName="email"
          placeholder="Cerca per email"
        />
      </div>
      <div>
        <label for="status">Cerca per telefono</label>
        <input
          id="filters-phone"
          type="text"
          formControlName="phone"
          placeholder="Cerca per telefono"
        />
      </div>
      <div>
        <label for="status">Cerca per età</label>
        <div
          class="age-filter"
          style="display: grid; grid-template-columns: 1fr 1fr"
        >
          <input
            id="filters-age_lower"
            type="number"
            formControlName="age_lower"
            placeholder="Da..."
            min="0"
            max="99"
          />
          <input
            id="filters-age_upper"
            type="number"
            formControlName="age_upper"
            placeholder="A..."
            min="0"
            max="99"
          />
        </div>
      </div>
      <hr
        class="w-100 my-3 text-white border-2 rounded border-light opacity-100"
      />
      <div class="elements-limit-container w-100">
        <label for="specialty" class="w-100">Specializzazioni:</label>
        <div class="d-flex justify-content-start text-xs">
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input
              type="checkbox"
              id="weight_loss"
              formControlName="weight_loss"
            />
            <label class="pointer" for="weight_loss">Perdita di peso</label>
          </div>
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input
              type="checkbox"
              id="sports_nutrition"
              formControlName="sports_nutrition"
            />
            <label class="pointer" for="sports_nutrition"
              >Nutrizione sportiva</label
            >
          </div>
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input
              type="checkbox"
              id="pathology_management"
              formControlName="pathology_management"
            />
            <label class="pointer" for="pathology_management"
              >Gestione delle patologie</label
            >
          </div>
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input
              type="checkbox"
              id="gastrointestinal_conditions"
              formControlName="gastrointestinal_conditions"
            />
            <label class="pointer" for="gastrointestinal_conditions"
              >Condizioni gastrointestinali</label
            >
          </div>
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input type="checkbox" id="education" formControlName="education" />
            <label class="pointer" for="education">Educazione alimentare</label>
          </div>
        </div>
      </div>
      <button
        class="reset-button"
        data-cy="reset-button"
        (click)="resetFilters()"
      >
        RESET
      </button>
    </form>
  </div>
  <div class="right-section">
    <div class="smaller-container">
      <p class="smaller-text">Nutrizionisti Family Happy</p>
      <div class="smaller-bar"></div>
    </div>

    <button
      class="my-button"
      id="new-nurse-button"
      (click)="rowClick(undefined)"
    >
      NUOVA
    </button>
    <div style="max-height: 70vh; overflow-y: auto">
      <table>
        <th>Nome</th>
        <th>Cognome</th>
        <th>Email</th>
        <th>Cellulare</th>
        <th>Elimina</th>
        <a
          *ngFor="let b of nutritionists"
          (click)="$event.stopPropagation(); rowClick(b)"
          [routerLink]="['/nutritionist-detail', b.doc_ref]"
          [href]="'/colf-detail' + b.doc_ref"
          class="link-no-style"
          style="display: table-row"
        >
          <td class="text-center">{{ b.name }}</td>
          <td class="text-center">{{ b.surname }}</td>
          <td class="text-center">{{ b.email }}</td>

          <td class="text-center">
            {{ b.phone
            }}<i
              class="ms-2 bi bi-clipboard"
              (click)="
                $event.stopImmediatePropagation();
                $event.preventDefault();
                copyToClipboard(b.phone)
              "
            ></i>
          </td>
          <td
            (click)="
              $event.stopImmediatePropagation();
              $event.preventDefault();
              deleteNutritionist(b.docRef)
            "
          >
            <span class="action-btn action-delete" title="Elimina">
              <i class="bi bi-trash3" style="font-size: 15px"></i>
            </span>
          </td>
        </a>
        <tr *ngIf="nutritionists.length === 0">
          <td colspan="7" style="text-align: center">
            Non sono stati trovati nutrizionisti che soddisfano i criteri di
            ricerca.
          </td>
        </tr>
      </table>
    </div>

    <div class="table-footer">
      <div></div>
      <div class="elements-limit-container">
        <label for="elements-number">Righe per pagina</label>
        <select id="elements-number" [formControl]="elementsPerPage">
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
        </select>
      </div>
    </div>
  </div>
</div>

<!--Alert section-->
<app-alert
  *ngIf="showAlert"
  (save)="onAlertConfimation($event)"
  [data]="{ type: undefined }"
  [title]="'Attenzione!'"
  [message]="'Vuoi davvero eliminare questo profilo nutrizionista?'"
>
</app-alert>
